export default "/images/vendor/flag-icon-css/flags/4x3/gr.svg?24e4280338bb1256957bdef8df14b137";